/**
 * IDs of known system alerts
 * this way we can easily ask to listen to any of these IDs
 * whereever we want, with out needing a connection to original alert creator class
 */
export const SystemAlertId = {
	emailNotVerified: 'app-alert-id:emailNotVerified',
	zone5AcceptancePending: 'app-alert-id:zone5AcceptancePending'
};
